import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { changePassword } from "@/lib/api";

export const RoleChangePasswordPage = ({ session, onPasswordChanged, onLogout }) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!currentPassword.trim() || !newPassword.trim() || !confirmPassword.trim()) {
      toast.error("Please fill all password fields");
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error("New password and confirm password must match");
      return;
    }
    if (newPassword.length < 8) {
      toast.error("New password must be at least 8 characters");
      return;
    }

    setLoading(true);
    try {
      await changePassword(session.token, {
        current_password: currentPassword,
        new_password: newPassword,
      });
      toast.success("Password updated successfully");
      onPasswordChanged();
    } catch (error) {
      toast.error(error?.response?.data?.detail || "Password update failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page-bg" data-testid="change-password-page">
      <div className="auth-card" data-testid="change-password-card">
        <h1 className="auth-title">First-time Password Setup</h1>
        <p className="auth-subtitle">Please change default password to continue</p>

        <form className="auth-form" onSubmit={handleSubmit} data-testid="change-password-form">
          <label>Current Password</label>
          <Input
            type="password"
            value={currentPassword}
            onChange={(event) => setCurrentPassword(event.target.value)}
            className="auth-input"
            data-testid="change-password-current"
          />

          <label>New Password</label>
          <Input
            type="password"
            value={newPassword}
            onChange={(event) => setNewPassword(event.target.value)}
            className="auth-input"
            data-testid="change-password-new"
          />

          <label>Confirm New Password</label>
          <Input
            type="password"
            value={confirmPassword}
            onChange={(event) => setConfirmPassword(event.target.value)}
            className="auth-input"
            data-testid="change-password-confirm"
          />

          <Button className="auth-submit-btn" type="submit" disabled={loading} data-testid="change-password-submit">
            {loading ? "Saving..." : "Save Password"}
          </Button>
          <Button type="button" variant="outline" className="auth-secondary-btn" onClick={onLogout} data-testid="change-password-logout">
            Logout
          </Button>
        </form>
      </div>
    </div>
  );
};
